import { render, staticRenderFns } from "./IlluEnglish.vue?vue&type=template&id=724df7b2&"
import script from "./IlluEnglish.vue?vue&type=script&lang=js&"
export * from "./IlluEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports